import React from 'react';
import { Link } from "react-router-dom";

// import { Container } from './styles';

function Componentes({ flagValidadoCertidao, flagValidadoBeneficiario, flagImportado, numrCpf, nomePessoa, numrCert }) {

  if (flagValidadoBeneficiario && flagValidadoCertidao) {

    if (!flagImportado) {
      return <span className={`customer-badge  status-valida-certidao-pendente`}>
        <i className={`pi pi-info`} ></i>
        Falta Importar
      </span>
    }

    return (
      <Link
        to={{
          pathname: `/manterObrigacao`,
          state: {
            cpf: numrCpf,
            nome: nomePessoa,
            numrCert: numrCert,
          },
        }}
        style={{ marginLeft: "5px" }}
      >
        <span className={`customer-badge  status-valida-certidao-concluido importado`}>
          <i className={`pi pi-check`} ></i>
        Importado
      </span>
      </Link >
    )

  }

  return <span style={{ display: 'flex', flexDirection: 'column' }}>
    <span className={`customer-badge  status-valida-certidao-${flagValidadoBeneficiario ? "concluido" : "pendente"}`}>
      <i className={`pi ${flagValidadoBeneficiario ? "pi-check" : "pi-info"}`} ></i>

      {
        flagValidadoBeneficiario ? 'Beneficiário Validado' : 'Beneficiário Pendente'
      }

    </span>

    <span className={`customer-badge  status-valida-certidao-${flagValidadoCertidao ? "concluido" : "pendente"}`}>
      <i className={`pi ${flagValidadoCertidao ? "pi-check" : "pi-info"}`} ></i>

      {
        flagValidadoCertidao ? 'Obrigação Validado' : 'Obrigação Pendente'
      }

    </span>
  </span>
}

export default Componentes;